<template>
  <v-container>
    <div class="page-title">補檢完成註記</div>
  </v-container>
</template>

<script>
export default {
  name: "Inspection",
  data: () => ({}),
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>